import { ManualTitle } from '../../component/ManualTitle';
import ManualPageList from '../../component/ManualPageList';
import ManualCategoryFaq from '../../component/ManualCategoryFaq';

export const ManualFaq007: React.FC = () => {
  return (
    <>
      <ManualTitle id="manual-007" SubTitle="よくあるご質問"></ManualTitle>
      <ManualCategoryFaq id="manual-007"></ManualCategoryFaq>
      <section className="section-common">
        <div className="container">
          <h4
            className="common-section-header has-text-centered has-text-weight-bold"
            id="contract"
          >
            契約内容について
          </h4>
          <div className="inner">
            <ul className="common-faq">
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  契約者以外も運転しても大丈夫でしょうか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      契約者と生計を一とする家族であれば運転は可能です。その際に任意保険の加入内容にもご留意いただくことをおすすめいたします。
                    </p>
                  </div>
                </div>
              </li>
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  契約期間中に別の車への乗り換えはできますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>契約途中でのお車の乗り換えはできません。</p>
                  </div>
                </div>
              </li>
            </ul>
            <p className="common-back-category has-text-right is-margin-top-7">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>

          <h4
            className="common-section-header has-text-centered has-text-weight-bold"
            id="payment"
          >
            お支払いについて
          </h4>
          <div className="inner">
            <ul className="common-faq">
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  口座引き落としに利用できない銀行はありますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      ゆうちょ銀行はご指定いただけません。
                      <br />
                      そのほか、一部のインターネット専業銀行、
                      信用金庫、農業協同組合、信漁連・漁業ではお取り扱いができない金融機関もございます。
                      <br />
                      上記金融機関からの引き落としをご希望の場合、
                      <a href="#footer" className="has-text-weight-normal">
                        カーリースカルモくんサポートデスク
                      </a>
                      にお問い合わせくださいませ。
                    </p>
                  </div>
                </div>
              </li>
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  クレジットカード払いはできますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>お支払い方法は口座振替のみとなります。</p>
                  </div>
                </div>
              </li>
            </ul>
            <p className="common-back-category has-text-right is-margin-top-7">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>

          <h4
            className="common-section-header has-text-centered has-text-weight-bold"
            id="accident"
          >
            事故・故障など トラブルについて
          </h4>
          <div className="inner">
            <ul className="common-faq">
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  災害や盗難の被害に遭った場合はどうなりますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      ご状況やお車の状態により、中途解約となる可能性がございます。まずは
                      <a href="#footer" className="has-text-weight-normal">
                        カーリースカルモくんサポートデスク
                      </a>
                      までご連絡ください。
                    </p>
                  </div>
                </div>
              </li>
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  事故で修理不能になった場合はどうなりますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      事故で修理不能など、ご契約車両が使用できなくなった場合、中途解約が必要となります。
                      <a href="#footer" className="has-text-weight-normal">
                        カーリースカルモくんサポートデスク
                      </a>
                      へご連絡ください。
                    </p>
                  </div>
                </div>
              </li>
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  傷や汚れをつけてしまった 場合、月々の値段は高くなりますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      傷や汚れによって、月々の料金が高くなるということは一切ございません。また、傷や汚れ以外の経年変化による塗装劣化などにつきましても、月額定額料金の中に含まれております。ご安心ください。
                    </p>
                    <p className="is-margin-top-4">
                      ただし、通常の使用による摩耗や軽微な傷の範囲を超えた傷・汚れなどについては、車両返却時に求償対象となる場合もございますのでご注意ください。
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <p className="common-back-category has-text-right is-margin-top-7">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>

          <h4
            className="common-section-header has-text-centered has-text-weight-bold"
            id="procedure"
          >
            お手続きについて
          </h4>
          <div className="inner">
            <ul className="common-faq">
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  引越しをすることになりました。どうすればよいでしょうか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      新しいご住所について
                      <a href="#footer" className="has-text-weight-normal">
                        カーリースカルモくんサポートデスク
                      </a>
                      にご連絡ください。リース車両のご移動はご自身で行なっていただきますようお願いいたします。
                    </p>
                  </div>
                </div>
              </li>
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  契約者が死亡した場合はどうしたらいいですか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      <a href="#footer" className="has-text-weight-normal">
                        カーリースカルモくんサポートデスク
                      </a>
                      までご連絡ください。
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <p className="common-back-category has-text-right is-margin-top-7">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>

          <h4
            className="common-section-header has-text-centered has-text-weight-bold"
            id="inspection"
          >
            カーライフサポートサービス全般について
          </h4>
          <div className="inner">
            <ul className="common-faq">
              <li className="common-faq-item">
                <p className="common-faq-question morelook-button">
                  毎年の自動車税はどうなりますか。
                </p>
                <div className="js-accordion-outerTgt">
                  <div className="common-faq-answer accordion-body">
                    <p>
                      月額料金に含まれており、お客様の対応はございません。
                      万一自治体より納税通知書が届いた場合は、
                      <a href="#footer" className="has-text-weight-normal">
                        カーリースカルモくんサポートデスク
                      </a>
                      までご連絡ください。
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <p className="common-back-category has-text-right is-margin-top-7 is-margin-bottom-7">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>
        </div>
      </section>
      <ManualPageList id="manual-007"></ManualPageList>
    </>
  );
};
